import React from 'react'
import Container from '@/components/Container/index'
import { Tabs } from 'antd';
import { connect } from 'dva';
import style from './index.less'
// eslint-disable-next-line import/no-cycle
import BirthdayPush from '../BrithdayCare/index'
import EntryPush from './entryPush/index'


const { TabPane } = Tabs;
@connect(({ getPushRuless }) => ({
  ...getPushRuless
}))
class BirthdayCare extends React.Component {

  callback = (key) => {
    const { history } = this.props
    history.push(key)
  }

  render () {
    const { location } = this.props
    return (
      <div className={style.birthday_root}>
        <Container>
          <Tabs type="card" activeKey={location.pathname} onTabClick={this.callback}>
            <TabPane tab="生日推送" key="/logistic/teachercare/pushrules/birthdaycare">
              <BirthdayPush />
            </TabPane>
            <TabPane tab="入职周年推送" key="/logistic/teachercare/pushrules/entrycare">
              <EntryPush />
            </TabPane>
          </Tabs>
        </Container>

      </div>
    )
  }

}


export default BirthdayCare;